//
// Copyright (c) 2024 Comcast
//

import PropTypes from 'prop-types'
import styled from 'styled-components'

import { StyledTableCell } from 'components/Shared/TableNew/TableCell'

const MIN_WIDTH = 328

export const StyledTableFormValueCell = styled(StyledTableCell)`
  min-width: ${MIN_WIDTH}px;
  padding: 12px;
  white-space: pre-line;
  word-wrap: break-word;
`

const TableFormValueCell = ({ children, width, height, align }) => {
  return (
    <StyledTableFormValueCell align={align || 'left'} width={width} height={height}>
      {children}
    </StyledTableFormValueCell>
  )
}

TableFormValueCell.propTypes = {
  children: PropTypes.node,
  width: PropTypes.string,
  height: PropTypes.string,
  align: PropTypes.string,
}

export default TableFormValueCell
